/**
 * Represents intents from the Search API.
 *
 * @public
 */
export enum SearchIntent {
  /** The Search API is requesting a prompt for the user's location. */
  NearMe = 'NEAR_ME'
}